import { render, staticRenderFns } from "./ProfileAdmin.vue?vue&type=template&id=241a5030&scoped=true&"
import script from "./ProfileAdmin.vue?vue&type=script&lang=js&"
export * from "./ProfileAdmin.vue?vue&type=script&lang=js&"
import style0 from "./ProfileAdmin.vue?vue&type=style&index=0&id=241a5030&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "241a5030",
  null
  
)

export default component.exports